import { render, staticRenderFns } from "./ATextArea.vue?vue&type=template&id=8a0439a2"
import script from "./ATextArea.vue?vue&type=script&lang=js"
export * from "./ATextArea.vue?vue&type=script&lang=js"
import style0 from "./ATextArea.vue?vue&type=style&index=0&id=8a0439a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports